<script>
  /** @type {string} */
  export let url

  import { onDestroy } from "svelte"
  import { goto } from "$app/navigation"
  import { page } from "$app/stores"

  import Dialog from "$lib/components/dialog/dialog.svelte"
  import DialogError from "$lib/components/dialog/dialog-error.svelte"
  import DialogHeader from "$lib/components/dialog/dialog-header.svelte"
  import ArrowRightIcon from "$lib/icons/arrow-right.svelte"
  import DevicePhoneMobileIcon from "$lib/icons/device-phone-mobile.svelte"
  import { checkWarpcastLogin } from "$lib/services/rpc-api"

  /** @type {string?} */
  let errorMessage = null
  let isOpen = false
  /** @type {NodeJS.Timeout} */
  let timer
  /** @type {number} */
  let startTime

  function closeModal() {
    isOpen = false
    clearTimeout(timer)

    const redirectUrl = new URL($page.url)
    redirectUrl.searchParams.delete("warpcast")
    redirectUrl.searchParams.delete("channel")

    goto(redirectUrl)
  }

  onDestroy(() => {
    clearTimeout(timer)
  })

  function checkStatus() {
    // Session expires after 30 minutes
    if (+(new Date()) - startTime > 1800_000) {
      closeModal()
    } else {
      clearTimeout(timer)
      timer = setTimeout(
        async () => {
          try {
            const channelToken = $page.url.searchParams.get("channel")
            if (channelToken) {
              const result = await checkWarpcastLogin({ channelToken }, { fetch })
              if (result.status === "fulfilled") {
                const loginUrl = new URL(`/login/${channelToken}`, $page.url)
                goto(loginUrl)
                return
              }
            }
          } catch (err) {
            // @todo
          }
          checkStatus()
        },
        2000,
      )
    }
  }

  export function open() {
    isOpen = true
    startTime = +(new Date())
    clearTimeout(timer)
    checkStatus()
  }
</script>

<Dialog bind:open={isOpen} on:close={closeModal} let:dialogTitleId classes={"top-full"}>
  <div class="flex flex-col">
    <DialogHeader headerText="Connect with Farcaster" {dialogTitleId} on:close={closeModal} />
    <div class="px-6 pt-3 flex flex-col space-y-4">
      <p>Scan with your phone to continue</p>
      <hr />

      <slot />

      <a href={url} target="_blank" class="text-[#7C65C1] flex flex-row justify-center items-center gap-2 pb-6">
        <DevicePhoneMobileIcon class="h-6 w-6" />
        <span>I'm using my phone</span>
        <ArrowRightIcon class="h-6 w-6" />
      </a>

      <DialogError bind:errorMessage={errorMessage} />
    </div>

    <!-- Can enable these items to debug the state transitions on this modal -->
    <!-- <pre>value = {JSON.stringify($stateService.value, null, 2)}</pre> -->
    <!-- <pre>context = {JSON.stringify($stateService.context, null, 2)}</pre> -->
  </div>
</Dialog>
